import { Box, Typography } from '@mui/material';
import ReferralStepBadge from './ReferralStepBadge';
import { resolveReferralStepText } from '../../services/referralService';

/** Figma 11147:1687 / 1692–1702 — how does it work steps */
export default function ReferralHowItWorks({ steps = [], layout = 'stacked' }) {
  if (!steps.length) return null;

  const isSideLayout = layout === 'side';

  return (
    <Box
      sx={{
        width: '100%', maxWidth: 390, mx: 'auto',
        pt: { xs: 0, md: isSideLayout ? 2 : 0 },
      }}
    >
      <Typography
        sx={{
          color: '#7000B9',
          textAlign: 'center',
          textShadow: '0 4px 4px rgba(0, 0, 0, 0.10)',
          fontFamily: 'Inter, sans-serif',
          fontSize: 24,
          fontWeight: 500,
          lineHeight: '32px',
          letterSpacing: '0.8px',
          mb: 3,
          WebkitTextStrokeWidth: 0.8,
          WebkitTextStrokeColor: '#FFF',
        }}
      >
        HOW DOES IT WORK?
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
        {steps.map((step, index) => {
          const stepText = resolveReferralStepText(step);
          if (!stepText) return null;

          return (
          <Box
            key={index}
            sx={{
              display: 'grid',
              gridTemplateColumns: '40px 1fr',
              gap: 1.5,
              alignItems: 'start',
            }}
          >
            <ReferralStepBadge value={String(index + 1).padStart(2, '0')} />

            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: 14,
                lineHeight: '20px',
                letterSpacing: '0.5px',
                color: '#fff',
                pt: 0.75,
              }}
            >
              {stepText}
            </Typography>
          </Box>
          );
        })}
      </Box>
    </Box>
  );
}
